import React, { useEffect, useReducer, useCallback, useState } from "react";
import {
  Row,
  Col,
  Select,
  Button,
  Popconfirm,
  Tooltip,
  Table,
  Input,
  Form,
  Modal,
  Divider,
  Typography,
  InputNumber,
  DatePicker,
  notification,
  Card,
  Spin,
  Checkbox,

} from "antd";
import * as XLSX from "xlsx";
import {
  CloseCircleFilled,
  DeleteFilled,
  ExportOutlined,
  PlusCircleOutlined,
  SyncOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";
import { BpiService } from "../Services/BpiService";
import { ExerciceDocService } from "../Services/ExerciceDocService";
import TableDOc from "./TableDoc";
import { AdherentsService } from "../Services/AdherentsService";
import { ParticipantsIpmService } from "../Services/ParticipantsIpmService";
import { TypesBenefsService } from "../Services/TypesBenefsServices";
import { ListFournisService } from "../Services/ListFournisService";
import { SpecialitesService } from "../Services/SpecialitesService";
import moment from "moment";
import dayjs from "dayjs";
const { Option } = Select;
const { Title, Text } = Typography;
const { confirm } = Modal;

const bpiService = new BpiService();
const exerciceDocService = new ExerciceDocService();
const adherentsService = new AdherentsService();
const participantsIpmService = new ParticipantsIpmService();
const specialistesService = new SpecialitesService();
const typesBenefsService = new TypesBenefsService();
const fournisseurService = new ListFournisService();

const userProfil = localStorage.getItem("profil");

const initialState = {
  selectedYear: new Date().getFullYear().toString(),
  addedRows: [],
  tableData: [],
  isExportModalVisible: false,
  selectedColumns: [], // Colonnes sélectionnées pour l'exportation
  filteredData: [],
  selectedOption: "nonTraite",
  filteredData: [],
  participantsData: null,
  isTableVisible: false,
  refreshTable: false,
  isRefreshing: false,
  medicamentsData: null,
  loading: false,
  benefsData: null,
  isSaisirMedicamentClicked: false,
  specialitesData: null,
  isEdit: false,
  prescripteursData: [],
  pharmaciesData: [],
  isMatriculeSelected: false,
  isBeneficiaireSelected: false,
  beneficiaires: [],
  isDateSelected: false,
  selectedRowData: null,
  addedMedicaments: [],
  isPrescripteurSelectEnabled: false,
  adherents: [],
  allBeneficiaires: [],
  years: [],
  isModalVisible: false,
  isSocieteSelectEnabled: true,
  isMatriculeSelectEnabled: false,
  isBeneficiaireSelectEnabled: false,
  isModalLoading: true,
  loadPharmacyData: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_SELECTED_YEAR":
      return { ...state, selectedYear: action.payload };
    case "SET_ADDED_ROWS":
      return { ...state, addedRows: action.payload };
    case "SET_TABLE_DATA":
      return { ...state, tableData: action.payload };
    case "SET_SELECTED_OPTION":
      return { ...state, selectedOption: action.payload };
    case "SET_FILTERED_DATA":
      return { ...state, filteredData: action.payload };
    case "SET_PARTICIPANTS_DATA":
      return { ...state, participantsData: action.payload };
    case "SET_IS_TABLE_VISIBLE":
      return { ...state, isTableVisible: action.payload };
    case "SET_REFRESH_TABLE":
      return { ...state, refreshTable: action.payload };
    case "SET_MEDICAMENTS_DATA":
      return { ...state, medicamentsData: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_BENEF_DATA":
      return { ...state, benefsData: action.payload };
    case "SET_IS_SAISIR_MEDICAMENT_CLICKED":
      return { ...state, isSaisirMedicamentClicked: action.payload };
    case "SET_SPECIALITES_DATA":
      return { ...state, specialitesData: action.payload };
    case "SET_IS_EDIT":
      return { ...state, isEdit: action.payload };
    case "SET_PRESCRIPTEURS_DATA":
      return { ...state, prescripteursData: action.payload };
    case "SET_PHARMACIES_DATA":
      return { ...state, pharmaciesData: action.payload };
    case "SET_IS_MATRICULE_SELECTED":
      return { ...state, isMatriculeSelected: action.payload };
    case "SET_IS_BENEFICIAIRE_SELECTED":
      return { ...state, isBeneficiaireSelected: action.payload };
    case "SET_BENEFICIAIRES":
      return { ...state, beneficiaires: action.payload };
    case "SET_IS_DATE_SELECTED":
      return { ...state, isDateSelected: action.payload };
    case "SET_SELECTED_ROW_DATA":
      return { ...state, selectedRowData: action.payload };
    case "SET_ADDED_MEDICAMENTS":
      return { ...state, addedMedicaments: action.payload };
    case "SET_IS_PRESCRIPTEUR_SELECT_ENABLED":
      return { ...state, isPrescripteurSelectEnabled: action.payload };
    case "SET_ADHERENTS":
      return { ...state, adherents: action.payload };
    case "SET_ALL_BENEFICIAIRES":
      return { ...state, allBeneficiaires: action.payload };
    case "SET_IS_EXPORT_MODAL_VISIBLE":
      return { ...state, isExportModalVisible: action.payload };
    case "SET_SELECTED_COLUMNS":
      return { ...state, selectedColumns: action.payload };
    case "SET_FILTERED_DATA":
      return { ...state, filteredData: action.payload };
    case "SET_YEARS":
      return { ...state, years: action.payload };
    case "SET_IS_MODAL_VISIBLE":
      return { ...state, isModalVisible: action.payload };
    case "SET_IS_SOCIETE_SELECT_ENABLED":
      return { ...state, isSocieteSelectEnabled: action.payload };
    case "SET_IS_MATRICULE_SELECT_ENABLED":
      return { ...state, isMatriculeSelectEnabled: action.payload };
    case "SET_IS_REFRESHING":
      return { ...state, isRefreshing: action.payload };
    case "SET_IS_BENEFICIAIRE_SELECT_ENABLED":
      return { ...state, isBeneficiaireSelectEnabled: action.payload };
    case "SET_LOAD_PHARMACY_DATA":
      return { ...state, loadPharmacyData: action.payload };
    case "SET_IS_MODAL_LOADING":
      return { ...state, isModalLoading: action.payload };
    case "SET_PARTICIPANT_DETAILS":
      return { ...state, participantDetails: action.payload };
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
}

const TicketRemb = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isParticipantInactive, setIsParticipantInactive] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [isBonManuel, setIsBonManuel] = useState(false); // État pour la case à cocher "Bon Manuel"

  // Fonction pour gérer le changement de la case à cocher
  const handleBonManuelChange = (e) => {
    setIsBonManuel(e.target.checked);
  };

  const [form] = Form.useForm();

  const fetchData = useCallback(async () => {
    try {
      const yearsData = await exerciceDocService.getAllExercicesDoc();
      dispatch({ type: "SET_YEARS", payload: yearsData });
      await fetchDataByOption(state.selectedOption);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  }, [state.selectedOption]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    fetchDataByOption(state.selectedOption);
  }, [state.selectedYear, state.selectedOption]);

  const handleDeleteline = async (numdoc) => {
    try {
      confirm({
        title: "Êtes-vous sûr de vouloir supprimer ce ticket ?",
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await bpiService.deleteDoc(numdoc);
            const updatedData = state.filteredData.filter(
              (item) => item.numdoc !== numdoc
            );
            dispatch({ type: "SET_FILTERED_DATA", payload: updatedData });
            notification.success({
              message: "Succès",
              description: "ticket supprimée avec succès",
            });
          } catch (error) {
            notification.error({
              message: "Erreur",
              description: "Erreur lors de la suppression du document",
            });
          }
        },
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la confirmation de la suppression",
      });
    }
  };


  const fetchDataByOption = async (option) => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      let data;
      switch (option) {
        case "traite":
          data = await bpiService.getAllTIC_OK(state.selectedYear);
          break;
        case "nonTraite":
          data = await bpiService.getAllTIC_KO(state.selectedYear);
          break;
        case "annule":
          data = await bpiService.getAllTIC_AN(state.selectedYear);
          break;
        case "tous":
          data = await bpiService.getAllTIC_AA(state.selectedYear);
          break;
        default:
          break;

      }
      dispatch({ type: "SET_TABLE_DATA", payload: data });
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "SET_LOADING", payload: false });
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des données",
      });
    }
  };

  useEffect(() => {
    dispatch({ type: "SET_FILTERED_DATA", payload: state.tableData });
  }, [state.tableData, state.refreshTable]);

  const handleSocieteChange = async (value) => {
    try {
      let participantsData;
      if (!state.isEdit) {
        participantsData = await participantsIpmService.getOneListtParticipant(
          value
        );
      } else {
        participantsData = await participantsIpmService.getOneEtParticipant(
          value
        );
      }
      dispatch({ type: "SET_PARTICIPANTS_DATA", payload: participantsData });
      dispatch({ type: "SET_IS_MATRICULE_SELECT_ENABLED", payload: false });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description:
          "Erreur lors de la récupération des données du participant",
      });
    }
  };

  const handleTypeBenefChange = async (value) => {
    try {
      const filteredBeneficiaires = state.allBeneficiaires.filter(
        (beneficiaire) => beneficiaire.codebenef === value
      );
      if (filteredBeneficiaires.length === 0) {
        form.setFieldsValue({
          matribenef: undefined,
        });
        dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
      } else {
        dispatch({ type: "SET_BENEFICIAIRES", payload: filteredBeneficiaires });
        dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: true });
        form.setFieldsValue({
          matribenef: filteredBeneficiaires[0].matribenef,
        });
      }
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors du filtrage des bénéficiaires",
      });
    }
  };

  const handleSelectChange = (value) => {
    dispatch({ type: "SET_SELECTED_OPTION", payload: value });
  };

  const handleYearChange = (value) => {
    dispatch({ type: "SET_SELECTED_YEAR", payload: value });
  };

  const fetchTypeBenef = async () => {
    try {
      const typeBenefData = await typesBenefsService.getAllTypesBenefs();
      dispatch({ type: "SET_BENEF_DATA", payload: typeBenefData });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const handleMatPartChange = async (value) => {
    try {
      const participantData = await participantsIpmService.getOneParticipant(value);
      if (participantData.suspension_part === "S") {
        setSelectedParticipant(participantData);
        setIsParticipantInactive(true);
        return;
      }

      dispatch({ type: "SET_IS_MATRICULE_SELECTED", payload: true });
      const benefData = await participantsIpmService.getBenefParticipant(value);
      dispatch({ type: "SET_ALL_BENEFICIAIRES", payload: benefData });
      dispatch({ type: "SET_BENEFICIAIRES", payload: benefData });
      dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
      dispatch({ type: "SET_PARTICIPANT_DETAILS", payload: participantData });
      form.setFieldsValue({
        codetype: undefined,
        matribenef: undefined,
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des données du participant",
      });
    }
  };


  const handleFournisseurChange = async (value) => {
    try {
      const allFournisseurs = await fournisseurService.getAllListFournis();
      const prescripteurs = allFournisseurs.filter(
        (fournisseur) => fournisseur.codespe === value
      );
      const pharmacies = allFournisseurs
        .filter((fournisseur) => fournisseur.codespe === "06")
        .map((pharmacie) => ({
          ...pharmacie,
          exclus: pharmacie.exclus !== undefined ? pharmacie.exclus : false, // Assurez-vous que 'exclus' est bien défini
        }));
      dispatch({ type: "SET_PRESCRIPTEURS_DATA", payload: prescripteurs });
      dispatch({
        type: "SET_IS_PRESCRIPTEUR_SELECT_ENABLED",
        payload: !!value,
      });
      dispatch({ type: "SET_PHARMACIES_DATA", payload: pharmacies });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des prescripteurs",
      });
    }
  };

  const handleSearch = (value) => {
    const filtered = state.tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    dispatch({ type: "SET_FILTERED_DATA", payload: filtered });
  };

  const fetchAdherents = async () => {
    try {
      const adherentsData = await adherentsService.getAllAdherents();
      dispatch({ type: "SET_ADHERENTS", payload: adherentsData });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const fetchFournis = async () => {
    try {
      const fournisseurs = await fournisseurService.getAllListFournis();
      const pharmacies = fournisseurs.filter(
        (fournisseur) => fournisseur.codespe === "06"
      );
      dispatch({ type: "SET_PHARMACIES_DATA", payload: pharmacies });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const fetchSpecialite = async () => {
    try {
      const specialites = await specialistesService.getAllSpecialites();
      dispatch({ type: "SET_SPECIALITES_DATA", payload: specialites });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const fetchMedoc = async (value) => {
    try {
      const medicaments = await participantsIpmService.getMedicamentList();
      dispatch({ type: "SET_MEDICAMENTS_DATA", payload: medicaments });
      dispatch({ type: "SET_IS_SAISIR_MEDICAMENT_CLICKED", payload: !!value });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const handleDateChange = (value) => {
    dispatch({ type: "SET_IS_DATE_SELECTED", payload: !!value });
  };

  const handleRefresh = async () => {
    dispatch({ type: "SET_IS_REFRESHING", payload: true });

    try {
      await fetchDataByOption(state.selectedOption);
      dispatch({ type: "SET_REFRESH_TABLE", payload: !state.refreshTable });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la rafraîchissement des données",
      });
    } finally {
      dispatch({ type: "SET_IS_REFRESHING", payload: false });
    }
  };

  const handleExportClick = () => {
    const columns = Object.keys(state.filteredData[0] || {});
    dispatch({ type: "SET_SELECTED_COLUMNS", payload: columns });
    dispatch({ type: "SET_IS_EXPORT_MODAL_VISIBLE", payload: true });
  };

  const handleExportModalOk = () => {
    const dataToExport = state.filteredData.map((row) => {
      const rowData = {};
      state.selectedColumns.forEach((column) => {
        rowData[column] = row[column];
      });
      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ExportData");

    XLSX.writeFile(workbook, "export.xlsx");
    dispatch({ type: "SET_IS_EXPORT_MODAL_VISIBLE", payload: false });
  };

  const handleExportModalCancel = () => {
    dispatch({ type: "SET_IS_EXPORT_MODAL_VISIBLE", payload: false });
  };

  const handleColumnChange = (checkedValues) => {
    dispatch({ type: "SET_SELECTED_COLUMNS", payload: checkedValues });
  };

  const handleAddRow = () => {
    const values = form.getFieldsValue();
    const { codeacte, qte, prix_unitaire } = values;
    const freel = qte * prix_unitaire;

    if (state.addedMedicaments.includes(codeacte)) {
      notification.warning({
        message: "Duplication",
        description: "Ce médicament a déjà été ajouté à la table.",
      });
      return;
    }

    // Trouvez le médicament correspondant à libacte pour obtenir la valeur de exclus
    const medicament = state.medicamentsData.find(
      (med) => med.codeacte === codeacte
    );
    const exclus = medicament ? medicament.exclus : false; // Utilisez la valeur de exclus du médicament ou false par défaut

    const newRow = {
      numero: state.addedRows.length + 1,
      codeacte,
      libacte: medicament.libacte,
      qte,
      prix_unitaire,
      freel,
      exclus, // Utilisez la valeur dynamique de exclus
    };

    dispatch({ type: "SET_ADDED_ROWS", payload: [...state.addedRows, newRow] });
    dispatch({
      type: "SET_ADDED_MEDICAMENTS",
      payload: [...state.addedMedicaments, codeacte],
    });
    dispatch({ type: "SET_IS_TABLE_VISIBLE", payload: true });
    form.setFieldsValue({
      qteTotal: isNaN(values.qteTotal) ? qte : values.qteTotal + qte,
    });
    form.resetFields(["codeacte", "qte", "prix_unitaire"]);
  };

  const handleDelete = (record) => {
    const updatedRows = state.addedRows.filter(
      (row) => row.numero !== record.numero
    );
    dispatch({ type: "SET_ADDED_ROWS", payload: updatedRows });
  };

  const handleClearTable = () => {
    dispatch({ type: "SET_ADDED_ROWS", payload: [] });
    dispatch({ type: "SET_ADDED_MEDICAMENTS", payload: [] });
  };

  const handleOpenModal = (isManual = false) => {
    setIsBonManuel(isManual);
    dispatch({ type: "SET_IS_MODAL_VISIBLE", payload: true });
    dispatch({ type: "SET_IS_MODAL_LOADING", payload: true });

    // Charger les données nécessaires pour le modal
    Promise.all([
      fetchAdherents(),
      fetchTypeBenef(),
      fetchFournis(),
      fetchSpecialite(),
    ])
      .then(() => {
        dispatch({ type: "SET_IS_MODAL_LOADING", payload: false });
      })
      .catch((error) => {
        notification.error({
          message: "Erreur",
          description: "Erreur lors du chargement des données",
        });
        dispatch({ type: "SET_IS_MODAL_LOADING", payload: false });
      });
  };

  const resetFormData = () => {
    form.resetFields(); // Réinitialiser les champs du formulaire

    // Réinitialiser les différents états à leurs valeurs initiales
    dispatch({ type: "SET_IS_TABLE_VISIBLE", payload: false });
    dispatch({ type: "SET_IS_PRESCRIPTEUR_SELECT_ENABLED", payload: false });
    dispatch({ type: "SET_IS_SAISIR_MEDICAMENT_CLICKED", payload: false });
    dispatch({ type: "SET_IS_MATRICULE_SELECTED", payload: false });
    dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
    dispatch({ type: "SET_IS_DATE_SELECTED", payload: false });
    dispatch({ type: "SET_SELECTED_ROW_DATA", payload: null });
    dispatch({ type: "SET_ADDED_ROWS", payload: [] });
    dispatch({ type: "SET_ADDED_MEDICAMENTS", payload: [] });
    dispatch({ type: "SET_IS_EDIT", payload: false });
    dispatch({ type: "SET_IS_SOCIETE_SELECT_ENABLED", payload: true });
    dispatch({ type: "SET_IS_MATRICULE_SELECT_ENABLED", payload: true });
    dispatch({ type: "SET_IS_BENEFICIAIRE_SELECT_ENABLED", payload: false });


  };

  useEffect(() => {
    if (!state.isModalVisible) {
      resetFormData();
    }
  }, [state.isModalVisible]);

  const handleCloseModal = () => {
    dispatch({ type: "SET_IS_MODAL_VISIBLE", payload: false });
    dispatch({ type: "SET_IS_EDIT", payload: false });
  };


  const handleEdit = async (record) => {
    console.log('handleEdit called with record:', record);
    dispatch({ type: "SET_IS_MODAL_VISIBLE", payload: true });
    dispatch({ type: "SET_IS_MODAL_LOADING", payload: true });
    dispatch({ type: "SET_IS_EDIT", payload: true });

    try {
      const details = await bpiService.GetDetailBpi(record.numdoc);
      console.log('details fetched:', details);

      const [
        adherentsData,
        participantsData,
        benefData,
        benefsData,
        specialites,
        prescripteursData,
        pharmaciesData,
      ] = await Promise.all([
        adherentsService.getAllAdherents(),
        participantsIpmService.getOneEtParticipant(record.codesoc),
        participantsIpmService.getBenefParticipant(record.matripart),
        typesBenefsService.getAllTypesBenefs(),
        specialistesService.getAllSpecialites(),
        fournisseurService.getAllListFournis(),
        fournisseurService.getAllListFournis(),
      ]);

      let medicamentsData = [];
      if (details.actes && details.actes.length > 0) {
        medicamentsData = await participantsIpmService.getMedicamentList();
      }

      console.log('details:', details);

      const selectedBenef = benefsData.find(
        (benef) => benef.codetype === details.typebenef
      );
      const codespe = details.codepresc.slice(0, 2);
      const prescripteur = prescripteursData.find(
        (prescripteur) => prescripteur.numFourn === details.codepresc
      );

      const selectedRowData = {
        ...details,
        datepresc: details.datepresc ? dayjs(details.datepresc) : undefined,
        datedoc: details.datedoc ? dayjs(details.datedoc) : undefined,
        libtype: selectedBenef ? selectedBenef.libtype : undefined,
        montant_remise: details.montant_remise,
        montdoc: details.montdoc,
        codespe: codespe,
        codepresc: prescripteur ? prescripteur.numFourn : undefined,
      };

      const addedRows = details.actes.map((line, index) => ({
        numero: index + 1,
        codeacte: line.codeacte,
        libacte: line.libacte,
        qte: line.qte || 0, // Assurez-vous que qte est défini
        prix_unitaire: line.prix_unitaire || 0, // Assurez-vous que prix_unitaire est défini
        freel: line.freel || 0, // Assurez-vous que freel est défini
        exclus: line.exclus || false,
      }));

      dispatch({ type: "SET_SELECTED_ROW_DATA", payload: selectedRowData });
      dispatch({ type: "SET_ADHERENTS", payload: adherentsData });
      dispatch({ type: "SET_PARTICIPANTS_DATA", payload: participantsData });
      dispatch({ type: "SET_BENEFICIAIRES", payload: benefData });
      dispatch({ type: "SET_BENEF_DATA", payload: benefsData });
      dispatch({ type: "SET_SPECIALITES_DATA", payload: specialites });
      dispatch({ type: "SET_PRESCRIPTEURS_DATA", payload: prescripteursData });
      dispatch({ type: "SET_PHARMACIES_DATA", payload: pharmaciesData });
      dispatch({ type: "SET_MEDICAMENTS_DATA", payload: medicamentsData });
      dispatch({ type: "SET_IS_MODAL_LOADING", payload: false });
      dispatch({ type: "SET_ADDED_ROWS", payload: addedRows });
      dispatch({ type: "SET_IS_TABLE_VISIBLE", payload: addedRows.length > 0 });

      console.log('selectedRowData set:', selectedRowData);
      console.log('addedRows set:', addedRows);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des détails",
      });
      dispatch({ type: "SET_IS_MODAL_LOADING", payload: false });
      console.error('Error in handleEdit:', error);
    }
  };

  const userId = localStorage.getItem('login');

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const participantDetails = state.participantDetails || { categprof: 'N/A' };
      const actes = state.addedRows.map((row) => {
        const selectedActe = state.medicamentsData.find(
          (acte) => acte.codeacte === row.codeacte
        );

        return {
          Prestation: selectedActe ? { ...selectedActe } : {},
          ajustmt: 0,
          codeprest: "",
          fexclus: 0,
          freel: row.freel,
          intitule: "",
          numdoc: "",
          numligne: null,
          numligne_acte: selectedActe ? selectedActe.codeacte : null,
          prix_unitaire: row.prix_unitaire,
          qpassur: 0,
          qpmut: 0,
          qte: row.qte,
          ticket: 0,
        };
      });

      const docData = {
        actes,
        categprof: participantDetails.categprof,
        codefourn: values.codefourn,
        codeprest: "06",
        codesoc: values.codesoc,
        codepresc: values.codepresc,
        datepresc: values.datepresc,
        matribenef: values.matribenef,
        matripart: values.matripart,
        montant_remise: values.montant_remise,
        montdoc: values.montdoc,
        nbarticle: values.nbarticle,
        numdoc: isBonManuel ? values.numdoc : null,
        datedoc: isBonManuel ? values.datedoc?.format("YYYY-MM-DD") : null,
        remb_integral: values.remb_integral || false,
        typebenef: values.typebenef,
        typedoc: "TIC",
        user_id: userId,
      };

      const response = await bpiService.AddDoc(docData);

      if (response.Added === false) {
        notification.error({
          message: "Erreur",
          description: "Numéro de bon déjà ajouté.",
        });
      } else {
        resetFormData();
        fetchDataByOption(state.selectedOption);

        notification.success({
          message: "Succès",
          description: "Le document a été ajouté avec succès.",
        });
      }
    } catch (error) {
      if (error instanceof Error) {
        notification.error({
          message: "Erreur",
          description: "Erreur lors de l'ajout du document: " + error.message,
        });
      } else {
        notification.error({
          message: "Validation échouée",
          description: error,
        });
      }
    }
  };


  const handleModif = () => {
    form
      .validateFields()
      .then(async (values) => {

        const actes = state.addedRows.map((row) => {
          const selectedActe = state.medicamentsData.find(
            (acte) => acte.codeacte === row.codeacte
          );

          return {
            Prestation: selectedActe ? { ...selectedActe } : {},
            ajustmt: 0,
            codeprest: "",
            fexclus: 0,
            freel: row.freel,
            intitule: "",
            numdoc: "",
            numligne: null,
            numligne_acte: selectedActe ? selectedActe.codeacte : null,
            prix_unitaire: row.prix_unitaire,
            qpassur: 0,
            qpmut: 0,
            qte: row.qte,
            ticket: 0,
          };
        });
        const docData = {
          actes,
          categprof: state.selectedRowData.categprof,
          codefourn: values.codefourn,
          codeprest: "06",
          codesoc: values.codesoc,
          codepresc: values.codepresc,
          datepresc: values.datepresc,
          matribenef: values.matribenef,
          matripart: values.matripart,
          montant_remise: values.montant_remise,
          montdoc: values.montdoc,
          nbarticle: values.nbarticle,
          numdoc: state.selectedRowData.numdoc,
          remb_integral: values.remb_integral || false,
          typebenef: values.typebenef,
          typedoc: "TIC",
          user_id: userId,
        };
        try {
          await bpiService.UpdateDetailBpi(docData);
          handleCloseModal();
          fetchDataByOption(state.selectedOption);
          notification.success({
            message: "Succès",
            description: "Le document a été modifié avec succès.",
          });
        } catch (error) {
          notification.error({
            message: "Erreur",
            description: "Erreur lors de l'ajout du document",
          });
        }
      })
      .catch((info) => {
        notification.error({
          message: "Validation échouée",
          description: info,
        });
      });
  };

  const formatNumberWithSeparator = (number) => {
    return number ? number.toLocaleString() : '0'; // Vérifiez que number est défini avant d'utiliser toLocaleString
  };

  return (
    <div>
      <Card>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: "40px" }}
        >
          <Col>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 20px",
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                borderRadius: 10,
                boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
              }}
            >
              <FileProtectOutlined style={{ fontSize: 22, color: "#fff" }} />
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#fff",
                  letterSpacing: 0.5,
                  margin: 0,
                }}
              >
                Tickets Remboursement
              </span>
            </div>
          </Col>
          <Col>
            <Select
              bordered={false}
              style={{
                width: 100,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={handleYearChange}
              value={state.selectedYear}
              showSearch
            >
              {state.years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>

            <Select
              bordered={false}
              style={{
                width: 200,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={handleSelectChange}
              value={state.selectedOption}
              showSearch
            >
              <Option value="tous">Tous les Documents</Option>
              <Option value="traite">Traité</Option>
              <Option value="nonTraite">Non Traité</Option>
            </Select>
            <Input
              placeholder="Recherche..."
              bordered={false}
              style={{
                width: 200,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <Button
              className="buttonRecep"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(false)}
              icon={<PlusCircleOutlined />}
            >
              Bon Auto
            </Button>
            <Button
              className="ButtonbonManuel"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(true)}
              icon={<PlusCircleOutlined />}
            >
              Bon Manuel
            </Button>

            <Button
              className="buttonExport"
              style={{ marginRight: 10 }}
              onClick={handleExportClick}
              icon={<ExportOutlined />}
            >
              Export
            </Button>
            <Button
              className="buttonRefresh"
              icon={
                state.isRefreshing ? <SyncOutlined spin /> : <SyncOutlined />
              }
              onClick={handleRefresh}
              disabled={state.isRefreshing}
            />
          </Col>
        </Row>
        <TableDOc
          bordered
          dataSource={state.filteredData}
          isPharmacieComponent={true}
          showAdditionalColumns={state.selectedOption === "traite"}
          handleDeleteline={handleDeleteline}
          onEdit={handleEdit}
          loading={state.loading}
        />
        <Modal
          open={state.isModalVisible}
          maskClosable={false}
          style={{ top: 20 }}
          footer={null}
          onCancel={handleCloseModal}
          destroyOnClose={true}
          width={1000}
          className="modal-header"

          title={
            <div>
              {state.isEdit
                ? "Modification de ticket remboursement"
                : "Création ticket remboursement"}
              {state.isEdit && (
                <div style={{ fontSize: "14px", marginTop: "2px" }}>
                  Numéro :{" "}
                  {state.selectedRowData ? state.selectedRowData.numdoc : ""}
                </div>
              )}
            </div>
          }
        >
          {state.isModalLoading ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <Spin size="large" />
            </div>
          ) : (
            <Form
              form={form}
              layout="vertical"
              initialValues={state.selectedRowData}
              preserve={false}
            >
              {isBonManuel && (
                <Row gutter={16}>
                  <Divider orientation="left">
                    Infos Bon
                  </Divider>

                  <>
                    <Col span={8}>
                      <Form.Item
                        name="numdoc"
                        label="Numéro Bon"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez entrer le numéro du bon",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="datedoc"
                        label="Date Bon"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner la date du bon",
                          },
                        ]}
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          disabledDate={(current) =>
                            current && current > moment().endOf("day")
                          }
                          style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="montdoc"
                        label="Montant Bon"
                        initialValue={0}
                      >
                        <InputNumber style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </>

                </Row>
              )}

              <Row gutter={16}>
                <Col span={12}>
                  <Divider orientation="left">
                    Participant
                  </Divider>
                  <Form.Item
                    name="codesoc"
                    label="Société"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une société",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      onChange={handleSocieteChange}
                      disabled={state.isSocieteSelectEnabled && state.isEdit}
                      showSearch
                    >
                      {state.adherents.map((adherent) => (
                        <Option
                          key={adherent.codeadht}
                          value={adherent.codeadht}
                        >
                          {`${adherent.codeadht} - ${adherent.intitule}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="matripart"
                    label="Matricule participant"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      disabled={
                        !state.participantsData ||
                        state.isMatriculeSelectEnabled
                      }
                      onChange={handleMatPartChange}
                      showSearch
                    >
                      {state.participantsData &&
                        state.participantsData.map((participant) => (
                          <Option
                            key={participant.numcont}
                            value={participant.numcont}
                          >
                            {`${participant.matricule} - ${state.isEdit
                                ? participant.prenom + " " + participant.nom
                                : participant.part
                              }`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Divider orientation="left">
                    Prescripteur
                  </Divider>
                  <Form.Item name="codespe" label="Spécialités">
                    <Select
                      style={{ width: "100%" }}
                      onChange={handleFournisseurChange}
                      showSearch
                    >
                      {state.specialitesData &&
                        state.specialitesData.map((specialite) => (
                          <Option
                            key={specialite.codespe}
                            value={specialite.codespe}
                          >
                            {`${specialite.codespe} - ${specialite.intitule}`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name="codepresc" label="Prescripteur">
                    <Select
                      style={{ width: "100%" }}
                      disabled={
                        !state.isPrescripteurSelectEnabled && !state.isEdit
                      }
                      showSearch
                    >
                      {state.prescripteursData.map((prescripteur) => (
                        <Option
                          key={prescripteur.numFourn}
                          value={prescripteur.numFourn}
                        >
                          {`${prescripteur.numFourn} - ${prescripteur.raisoc}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Divider orientation="left">
                    Bénéficiaire
                  </Divider>
                  <Form.Item
                    name="typebenef"
                    label="Types"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      defaultValue="--Selectionner--"
                      onChange={handleTypeBenefChange}
                      disabled={!state.isMatriculeSelected && !state.isEdit}
                      value={state.selectedRowData?.libtype || undefined}
                      showSearch
                    >
                      {state.benefsData &&
                        state.benefsData.map((benefData) => (
                          <Option
                            key={benefData.codetype}
                            value={benefData.codetype}
                          >
                            {benefData.libtype}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="matribenef"
                    label="Bénéficiaire"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select
                      defaultValue="--Selectionner--"
                      style={{ width: "100%" }}
                      disabled={!state.isBeneficiaireSelected && !state.isEdit}
                      showSearch
                    >
                      {(state.beneficiaires || []).map((beneficiaire) => (
                        <Option
                          key={beneficiaire.matribenef}
                          value={beneficiaire.matribenef}
                        >
                          {`${beneficiaire.matribenef} - ${beneficiaire.prenoms ? beneficiaire.prenoms + " " : ""
                            }${beneficiaire.nom ? beneficiaire.nom : ""}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Divider orientation="left">
                    Pharmacie
                  </Divider>
                  <Form.Item
                    name="codefourn"
                    label="Pharmacie"

                  >
                    <Select
                      style={{ width: "100%" }}
                      defaultValue={"--Selectionner"}
                      disabled={
                        (!state.participantsData ||
                          state.isMatriculeSelectEnabled) &&
                        !state.isEdit
                      }
                      showSearch
                    >
                      {state.pharmaciesData &&
                        state.pharmaciesData.map((pharmacie) => (
                          <Option
                            key={pharmacie.numFourn}
                            value={pharmacie.numFourn}
                          >
                            {`${pharmacie.numFourn} - ${pharmacie.raisoc}`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Divider orientation="left">
                    Ordonnance
                  </Divider>
                  <Row gutter={16}>
                    <Form.Item
                      name="nbarticle"
                      initialValue={0}
                      label="Nombre d'article"
                    >
                      <InputNumber
                        disabled={
                          !state.isPrescripteurSelectEnabled && !state.isEdit
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      name="datepresc"
                      label="Date d'ordonnance"
                      style={{ marginRight: "16px" }}
                    >
                      <DatePicker
                        disabledDate={(current) =>
                          current && current > dayjs().endOf("day")
                        }
                        disabled={
                          !state.isPrescripteurSelectEnabled && !state.isEdit
                        }
                        onChange={handleDateChange}
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                    <Form.Item
                      name="qteTotal"
                      label="quantité totale"
                      initialValue={0}
                    >
                      <InputNumber
                        disabled={
                          !state.isPrescripteurSelectEnabled && !state.isEdit
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name="montant_remise"
                      initialValue={0}
                      label="Remise"
                    >
                      <InputNumber
                        disabled={
                          !state.isPrescripteurSelectEnabled && !state.isEdit
                        }
                      /></Form.Item>
                  </Row>
                  <Form.Item name="codeacte">
                    <Select
                      style={{ width: "100%" }}
                      defaultValue="Saisir le médicament"
                      showSearch
                      disabled={
                        (!state.isPrescripteurSelectEnabled ||
                          !state.isDateSelected) &&
                        !state.isEdit
                      }
                      onClick={fetchMedoc}
                    >
                      {state.medicamentsData &&
                        state.medicamentsData.map((medicament) => (
                          <Option
                            key={medicament.codeacte}
                            value={medicament.codeacte}
                          >
                            {`${medicament.libacte} `}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item
                        name="qte"
                        label="Qté"
                        className={
                          state.isSaisirMedicamentClicked ? "" : "hidden"
                        }
                        initialValue={1}
                      >
                        <InputNumber />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name="prix_unitaire"
                        label="P.U"
                        className={
                          state.isSaisirMedicamentClicked ? "" : "hidden"
                        }
                        initialValue={0}
                      >
                        <InputNumber />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <PlusCircleOutlined
                        style={{
                          fontSize: "30px",
                          paddingTop: "30px",
                          color: "#4DBD74",
                        }}
                        className={
                          state.isSaisirMedicamentClicked ? "" : "hidden"
                        }
                        onClick={handleAddRow}
                      />
                      <CloseCircleFilled
                        style={{
                          fontSize: "30px",
                          paddingTop: "30px",
                          paddingLeft: "8px",
                          color: "#ff2317",
                        }}
                        className={
                          state.isSaisirMedicamentClicked ? "" : "hidden"
                        }
                        onClick={handleClearTable}
                      />
                    </Col>
                  </Row>
                  {state.isTableVisible && state.addedRows.length > 0 && (
                    <Table
                      style={{
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}
                      showSorterTooltip={false}
                      className="custom-header1-table"
                      bordered
                      dataSource={[...state.addedRows]}
                      scroll={{ x: true }}
                      columns={[
                        {
                          title: "N°",
                          dataIndex: "numero",
                          key: "numero",
                          align: "center",
                        },
                        {
                          title: "Nom",
                          dataIndex: "libacte",
                          key: "libacte",
                        },
                        {
                          title: "Qt",
                          dataIndex: "qte",
                          key: "qte",
                          align: "center",
                        },
                        {
                          title: "P.U",
                          dataIndex: "prix_unitaire",
                          key: "prix_unitaire",
                          align: "right",
                          render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
                        },
                        {
                          title: "Montant",
                          dataIndex: "freel",
                          key: "freel",
                          align: "right",
                          render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
                        },

                        {
                          title: "Exclus",
                          dataIndex: "exclus",
                          key: "exclus",
                          align: "center",
                          render: (text, record) => (
                            <Checkbox checked={record.exclus} />
                          ),
                        },
                        {
                          title: (
                            <div
                              style={{
                                backgroundColor: "#010f1c",
                                color: "white",
                                padding: "1px",
                              }}
                            ></div>
                          ),
                          dataIndex: "actions",
                          key: "actions",
                          align: "center",
                          fixed: "right",
                          render: (text, record) => (
                            <span>
                              <Popconfirm
                                title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
                                onConfirm={() => handleDelete(record)}
                                okText="Oui"
                                cancelText="Non"
                              >
                                <Tooltip title="Supprimer">
                                  <DeleteFilled
                                    style={{ cursor: "pointer", color: "red" }}
                                  />
                                </Tooltip>
                              </Popconfirm>
                            </span>
                          ),
                        },
                      ]}
                      summary={(pageData) => {
                        let totalFreel = 0;
                        pageData.forEach((item) => {
                          totalFreel += item.freel;
                        });
                        return (
                          <Table.Summary.Row align="right" justify>
                            <Table.Summary.Cell index={0}>
                              <strong>Total</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1}></Table.Summary.Cell>
                            <Table.Summary.Cell index={2}></Table.Summary.Cell>
                            <Table.Summary.Cell index={3}></Table.Summary.Cell>
                            <Table.Summary.Cell index={4}>
                              <Text>
                                <strong>{formatNumberWithSeparator(totalFreel)}</strong>
                              </Text>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        );
                      }}
                    />
                  )}
                </Col>
              </Row>
              <div
                style={{
                  marginTop: "20px",
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Form.Item name="remb_integral" style={{ marginBottom: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: 12,
                    }}
                  >
                    <span style={{ marginRight: "8px" }}>
                      Remboursement Intégral
                    </span>
                    <Checkbox></Checkbox>
                  </div>
                </Form.Item>
                <Button
                  type="dashed"
                  danger
                  onClick={handleCloseModal}
                  style={{ marginRight: 12 }}
                >
                  Annuler
                </Button>
                {state.isEdit ? (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#010f1c" }}
                    onClick={handleModif}
                  >
                    Modifier
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#010f1c" }}
                    onClick={handleOk}
                  >
                    Valider
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Modal>
        <Modal
          open={state.isExportModalVisible}
          onCancel={handleExportModalCancel}
          onOk={handleExportModalOk}
          title="Sélectionner les colonnes à exporter"
        >
          <Checkbox.Group
            style={{ width: "100%" }}
            value={state.selectedColumns}
            onChange={handleColumnChange}
          >
            <Row>
              {Object.keys(state.filteredData[0] || {}).map((col) => (
                <Col span={8} key={col}>
                  <Checkbox value={col}>{col}</Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Modal>
        <Modal
          open={isParticipantInactive}
          title="Participant inactif!"
          onCancel={() => {
            setIsParticipantInactive(false);
            setSelectedParticipant(null);
          }}
          footer={
            userProfil === 'role_1' || userProfil === 'role_2' ? (
              [
                <Button key="cancel" onClick={() => {
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                  form.resetFields(['matripart']);
                }}>
                  Annuler
                </Button>,
                <Button key="confirm" type="primary" onClick={async () => {
                  try {
                    const benefData = await participantsIpmService.getBenefParticipant(selectedParticipant.numcont);
                    dispatch({ type: "SET_IS_MATRICULE_SELECTED", payload: true });
                    dispatch({ type: "SET_ALL_BENEFICIAIRES", payload: benefData });
                    dispatch({ type: "SET_BENEFICIAIRES", payload: benefData });
                    dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
                    dispatch({ type: "SET_PARTICIPANT_DETAILS", payload: selectedParticipant });
                    form.setFieldsValue({
                      codetype: undefined,
                      matribenef: undefined,
                    });
                  } catch (error) {
                    notification.error({
                      message: "Erreur",
                      description: "Erreur lors de la récupération des bénéficiaires",
                    });
                  } finally {
                    setIsParticipantInactive(false);
                    setSelectedParticipant(null);
                  }
                }}>
                  Valider
                </Button>
              ]
            ) : (
              [
                <Button key="ok" type="primary" onClick={() => {
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                  form.resetFields(['matripart']);
                }}>
                  Ok
                </Button>
              ]
            )
          }
        >
          <p>Participant inactif! Veuillez confirmer cette opération.</p>
        </Modal>


      </Card>
    </div>
  );
};

export default TicketRemb;
